/* eslint-disable no-else-return */
/* eslint-disable arrow-parens */
/* eslint-disable no-underscore-dangle */
/* eslint-disable arrow-body-style */
/* eslint-disable no-fallthrough */
/* eslint-disable default-case */
/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/indent */
import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
    HttpResponse
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Auth0TokenService } from '@sondermind/host-auth';

import { ConfigurationService } from '@sondermind/configuration';
import { AUTH_SERVICE, IAuthService } from '@sondermind/utilities/models-auth';
import { IAPIErrorHandlingOptions, IHttpErrorHandler, ServerResponse } from '@sondermind/utilities/models-http';

import { HttpOptions } from './http_options';

type UrlBuilder = string | [string, any];

const NeedAuth = {
    header: 'X-Need-Auth',
    legacy: 'legacy',
    oauth: 'oauth '
};

/**
 * @deprecated - Please instead use @sondermind/data-access /http.
 */
@Injectable({ providedIn: 'root' })
export abstract class SondermindHttpService implements IHttpErrorHandler {
    constructor(
        private configurationService: ConfigurationService,
        private _http: HttpClient,
        private injector: Injector,
        private auth0Service: Auth0TokenService
    ) { }

    // auth token has a circular dependency with http (via HTTP_ERROR_HANDLERS )
    // so get it dynamically through the injector
    get authTokenSvc(): IAuthService {
        return this.injector.get(AUTH_SERVICE);
    }

    // error handling parity core/commo n
    // when 401 or 403 clear the tokens
    handleHttpError(err: HttpErrorResponse, _opts: IAPIErrorHandlingOptions) {
        if (err.status === 401 || err.status === 403) {
            this.authTokenSvc.reset();
        }

        return null;
    }

    /**
     * Implementing this function simply to adhere to IHttpErrorHandler interface.
     * Since this service is deprecated, this function should never be utilize d.
     */
    handleHttpErrorStrict<T>(err: HttpErrorResponse, options: IAPIErrorHandlingOptions): Observable<T> {
      return throwError(() => err);
    }

    // when 401 or 403 clear the tokens - this will force a refresh, which may cause login screen
    handleUnAuthorized(response: HttpResponse<any>): Observable<any> {
        if (response.status === 401 || response.status === 403) {
            this.authTokenSvc.reset();
        }

        return null;
    }

    // Use this to generate a url to the sonder mind server .
    // params: url - format of "/users/:user_id.jso n
    // params: params - Hash of keys and values .
    // returns : new url with all parameter change out.
    generateUrl(path: string, params: object = {}): string {
        // eslint-disable-next-line no-param-reassign
        path = path.replace(/:([a-zA-Z_]*)/g, (m, s) => params[s] || `:${s}`);

        return `${this.configurationService.env.apiBase}${path}`;
    }

    // create a request option object that has the oauth headers pre filled out.
    oauthRequestOptions(options: Partial<HttpOptions> = {}): HttpOptions {
        return { ...options, headers: this.getOAuthHeaders() };
    }

    // Create a request option object that has the auth headers pre filled out.
    authRequestOptions(options: Partial<HttpOptions> = {}): HttpOptions {
        return { ...options, headers: this.getHeaders(true) };
    }

    // Create a request option object that has no auth headers.
    noAuthRequestOptions(options: Partial<HttpOptions> = {}): HttpOptions {
        return { ...options, headers: this.getHeaders(false) };
    }

    private getDefaultHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json'
        });
    }

    private getHeaders(includeToken: boolean = true): HttpHeaders {
        let headers = this.getDefaultHeaders();
        // Auth 0 is being used, get out, we don't want these other Auth headers.
        if (this.auth0Service.auth0Enabled) {
            return headers;
        }
        if (includeToken) {
            headers = headers.append(NeedAuth.header, NeedAuth.legacy);
        } else {
          headers = headers.append('Authorization', 'None');
        }

        return headers;
    }

    private getOAuthHeaders(): HttpHeaders {
        let headers = this.getDefaultHeaders();
        headers = headers.append(NeedAuth.header, NeedAuth.oauth);

        return headers;
    }

    // do we even need to resolve headers?
    private needResolveHeaders(options: Partial<HttpOptions>): boolean {
        return options && options.headers && options.headers.has(NeedAuth.header);
    }

    // resolve the NeedAuth replacements in the request headers
    private resolveHeaders(options: Partial<HttpOptions>): Partial<HttpOptions> {
        const needAuth = options && options.headers && options.headers.get(NeedAuth.header);
        if (needAuth) {
            // In admin-access mode the token lives outside the OAuth live set, so
            // getAuthToken() would yield an empty `Bearer` header. Leave Authorization unset
            // (only clear the marker) so the request reaches the auth interceptor clean and its
            // admin branch attaches the admin access token and X-Provider-Id header itself.
            if (this.authTokenSvc.isAdminAccessMode()) {
                options.headers = options.headers.delete(NeedAuth.header);
                return options;
            }
            if (this.authTokenSvc.isAuthenticated()) {
                switch (needAuth) {
                    case NeedAuth.legacy:
                        // Fall through since auth svc's token shim will provide
                        // what's needed
                    case NeedAuth.oauth:
                        const token = this.authTokenSvc.getAuthToken();
                        options.headers = options.headers.append('Authorization', `Bearer ${token}`);
                        break;
                }
            } else {
                // we explicitly _don't_ have valid tokens, so we must be attempting to let a
                // request fail after we've tried to refresh them - the failed request kicks off
                // the error handling pipeline, so just give a bad authorization header to avoid
                // attempting another round of JIT refreshes in the interceptor.
                options.headers = options.headers.append('Authorization', 'None');
            }

            // clear the marker
            options.headers = options.headers.delete(NeedAuth.header);
        }

        return options;
    }

    // return the actual set of request options, with NeedAuthHeader resolved
    private resolveOptions(options: Partial<HttpOptions>): Observable<Partial<HttpOptions>> {
        if (!this.authTokenSvc.isAuthenticated()) {
            if (this.needResolveHeaders(options)) {
                return this.authTokenSvc.silentRefresh().pipe(
                    map(() => this.resolveHeaders(options))
                );
            }
        }

        return of(this.resolveHeaders(options));
    }

    handleErrorObject<T = any>(error: HttpResponse<any>, object_name): Observable<ServerResponse<T>> {
        const login_check = this.handleUnAuthorized(error);
        if (login_check != null) {
            return login_check;
        }

        const server_response = new ServerResponse<T>(error, object_name);
        return throwError(server_response);
    }

    processServerResponse(res: HttpResponse<any>, object_name): ServerResponse {
        const server_response = new ServerResponse(res, object_name);
        return server_response;
    }

    handleError<T = any>(error: HttpResponse<any>): Observable<T> {
        const login_check = this.handleUnAuthorized(error);
        if (login_check != null) {
            return login_check;
        }

        // eslint-disable-next-line no-console
        console.error(error);
        return throwError(error || 'Server error');
    }

    isImpersonating(): boolean {
        return this.authTokenSvc.isLegacyImpersonating();
    }

    // proxy http requests to the http service

    get<T = any>(url: UrlBuilder, options?: HttpOptions): Observable<HttpResponse<T>> {
        return this
            .resolveOptions(options)
            .pipe(switchMap(o => {
                return this.execute(
                    this._http.get<T>(this.buildUrl(url), { ...o, observe: 'response' })
                );
            }));
    }

    post<T = any>(url: UrlBuilder, body: any, options?: HttpOptions): Observable<HttpResponse<T>> {
        return this
            .resolveOptions(options)
            .pipe(switchMap(o => {
                return this.execute(
                    this._http.post<T>(this.buildUrl(url), body, { ...o, observe: 'response' })
                );
            }));
    }

    put<T = any>(url: UrlBuilder, body: any, options?: HttpOptions): Observable<HttpResponse<T>> {
        return this
            .resolveOptions(options)
            .pipe(switchMap(o => {
                return this.execute(
                    this._http.put<T>(this.buildUrl(url), body, { ...o, observe: 'response' })
                );
            }));
    }

    delete<T = any>(url: UrlBuilder, options?: HttpOptions): Observable<HttpResponse<T>> {
        return this
            .resolveOptions(options)
            .pipe(switchMap(o => {
                return this.execute(
                    this._http.delete<T>(this.buildUrl(url), { ...o, observe: 'response' })
                );
            }));
    }

    patch<T = any>(url: UrlBuilder, body: any, options?: HttpOptions): Observable<HttpResponse<T>> {
        return this
            .resolveOptions(options)
            .pipe(switchMap(o => {
                return this.execute(
                    this._http.patch<T>(this.buildUrl(url), body, { ...o, observe: 'response' })
                );
            }));
    }

    beforeRequest() {
        // nop
    }

    afterRequest(response: any) {
        // nop
    }

    afterRequestError(error: any) {
        // nop
    }

    private execute<T>(obs: Observable<T>): Observable<T> {
        return new Observable<T>(event => {
            this.beforeRequest();
            obs.subscribe({
                next: (resp) => {
                    this.afterRequest(resp);
                    event.next(resp);
                },
                error: (err) => {
                    this.afterRequestError(err);
                    event.error(err);
                },
                complete: () => {
                    event.complete();
                }
            });
        });
    }

    private buildUrl(url: UrlBuilder): string {
        if (typeof url === 'string') {
            if (!url.startsWith('/')) {
                return url;
            }

            return this.generateUrl(url);
        } else {
            return this.generateUrl(url[0], url[1]);
        }
    }
}
